import { z } from 'zod'

import { SETTABLE_USER_STATUSES } from '@/features/admin/constants'

/**
 * The user directory keeps its filters in the URL, the same discipline `customers/search.ts`
 * documents for the same reason: a filtered view is a place worth bookmarking or sending to a
 * colleague, and every member is optional so a bare `/admin/users` link is always valid.
 */

export const DEFAULT_PAGE_SIZE = 25

export const adminUserListSearchSchema = z.object({
  search: z.string().trim().min(1).optional().catch(undefined),
  status: z.enum(SETTABLE_USER_STATUSES).optional().catch(undefined),
  branchId: z.string().min(1).optional().catch(undefined),
  page: z.number().int().min(1).optional().catch(undefined),
  pageSize: z.number().int().min(10).max(200).optional().catch(undefined),
})

export type AdminUserListSearch = z.infer<typeof adminUserListSearchSchema>
